import s from "./CategoryCardList.module.scss";
import CategorySearch from "./CategorySearch";

const CATEGORY_COLORS = [
    "#FF6B6B",
    "#4ECDC4",
    "#C7F464",
    "#FFB400",
    "#6C5CE7",
    "#45B7D1",
    "#96CEB4",
];

const CategoryFixed = ({categories, onCategoryClick,activeCategory}) => {
    return (
        <div className={s.categoryList}>
            <CategorySearch/>

            {categories.slice(0, 7).map((item, i) => {
                return (

                    <div
                        key={i}
                        className={`${s.item} ${activeCategory == item.id ? s.active : ""}`}
                        // style={{ flex: `0 0 ${100 / itemsPerView}%` }}
                        onClick={() => {

                            onCategoryClick(item.id)
                        }}
                    >
                        <div className={s.card}>
                            <img src={item.thumb} alt=""/>
                            <div className={s.overlayBelow}>
                                <div className={s.svgBg}  style={{color: CATEGORY_COLORS[i]}}>
                                    {/* INLINE SVG */}
                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 607 259"
                                         className={s.svgShape}>
                                        <path
                                            d="M0 0 C191.73 0 383.46 0 581 0 C582.32 4.29 583.64 8.58 585 13 C590.9923199 21.65557319 596.51433009 23.66985113 607 26 C607 54.38 607 82.76 607 112 C604.36 113.32 601.72 114.64 599 116 C592.81771886 123.48381402 592.10978803 131.62529862 593 141 C594.23358586 145.99435573 595.83006153 149.80006311 599.4375 153.5 C602.31510031 155.26962066 602.31510031 155.26962066 607 157 C607 182.08 607 207.16 607 233 C603.37 233.99 599.74 234.98 596 236 C586.0427583 242.31092784 584.23626062 247.13371105 581 259 C389.27 259 197.54 259 0 259 C-0.99 255.04 -1.98 251.08 -3 247 C-9.27901202 238.30598335 -14.45482451 235.63629387 -25 233 C-25 207.92 -25 182.84 -25 157 C-19 154 -19 154 -17 154 C-16.32438252 152.3369416 -15.66066719 150.66905395 -15 149 C-14.74734375 148.39542969 -14.4946875 147.79085937 -14.234375 147.16796875 C-10.54081215 137.98837873 -10.57468115 131.28105066 -14 122 C-17.0011318 116.10491969 -18.70905893 115.59482347 -25 112 C-25 83.62 -25 55.24 -25 26 C-19.555 24.515 -19.555 24.515 -14 23 C-4.89078922 16.32846534 -2.5035732 11.26607941 0 0 Z "
                                            fill="currentColor" transform="translate(25,1)"/>
                                        <path
                                            d="M0 0 C191.73 0 383.46 0 581 0 C582.35439668 2.70879335 582.06501451 5.00933268 582 8 C581.67 6.68 581.34 5.36 581 4 C580.34 4 579.68 4 579 4 C579 3.01 579 2.02 579 1 C388.26 1 197.52 1 1 1 C0.67 4.3 0.34 7.6 0 11 C-0.66 11 -1.32 11 -2 11 C-1.34 7.37 -0.68 3.74 0 0 Z "
                                            fill="currentColor" transform="translate(25,1)"/>
                                        <path
                                            d="M0 0 C0 3 0 3 -1.79296875 4.82421875 C-2.58316406 5.43910156 -3.37335937 6.05398437 -4.1875 6.6875 C-4.96480469 7.31011719 -5.74210938 7.93273437 -6.54296875 8.57421875 C-9.30032226 10.17427285 -10.86748982 10.29488995 -14 10 C-14 10.66 -14 11.32 -14 12 C-15.32 12 -16.64 12 -18 12 C-18 39.39 -18 66.78 -18 95 C-17.01 95 -16.02 95 -15 95 C-14.67 95.99 -14.34 96.98 -14 98 C-15.65 97.34 -17.3 96.68 -19 96 C-19 67.62 -19 39.24 -19 10 C-15.37 9.01 -11.74 8.02 -8 7 C-5.20309963 5.33372465 -5.20309963 5.33372465 -3.3125 3.3125 C-2.34763672 2.37857422 -2.34763672 2.37857422 -1.36328125 1.42578125 C-0.91339844 0.95527344 -0.46351562 0.48476563 0 0 Z "
                                            fill="currentColor" transform="translate(19,17)"/>
                                        <path
                                            d="M0 0 C0.66 0.33 1.32 0.66 2 1 C1.505 1.99 1.01 2.98 0.5 4 C-2.06344187 10.64328597 -1.22920809 18.0049088 -1 25 C-1.66 25 -2.32 25 -3 25 C-3.08132642 21.95778935 -3.14065374 18.9177762 -3.1875 15.875 C-3.21263672 15.0190625 -3.23777344 14.163125 -3.26367188 13.28125 C-3.32398809 8.05384474 -2.85261993 4.56718676 0 0 Z "
                                            fill="currentColor" transform="translate(619,120)"/>
                                    </svg>
                                </div>
                                <div className={s.overlayBelowText}> {item.name}</div>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )

};

export default CategoryFixed;
